module.exports = "/call-frontend/img/select_model_bg.5eecbc20.png";